// extracted by mini-css-extract-plugin
export default {"feedbackForm":"style_feedbackForm__7Jh6S"};